import axios from 'axios';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '/api/';
const SECRETKEY = 'SKILLED@2024';

const tokenClient = axios.create({
    baseURL: API_ENDPOINT,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

const client = axios.create({
    baseURL: API_ENDPOINT,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

const clientWithoutToken = axios.create({
    baseURL: API_ENDPOINT,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

client.interceptors.request.use(async (config) => {
    const requestConfig = config;
    const { headers } = config;
    const response = await tokenClient.get('/guestToken');

    if (response?.data?.redirect === '/dashboard') {
        Cookies.set('SangLoggedIn', true);
        Cookies.set('SangLoggedData', JSON.stringify(response.data.data));
        window.location.href = '/dashboard';
    }

    requestConfig.headers = {
        ...headers,
        Authorization: response?.data?.accessToken ? `Bearer ${response.data.accessToken}` : '',
    };

    return requestConfig;
});

class GuestService {
    static checkOnline() {
        if (!navigator.onLine) {
            throw new Error('You are offline. Please check your internet connection.');
        }
    }

    static get(path = '') {
        this.checkOnline();
        return client({
            method: 'GET',
            url: path,
            headers: {},
        });
    }

    static post(path = '', data = {}, optionalHeader = {}) {
        this.checkOnline();
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRETKEY).toString();

        return client({
            method: 'POST',
            url: path,
            data: { encryptedData },
            headers: { ...optionalHeader },
        });
    }

    static delete(path = '', data = {}) {
        this.checkOnline();
        return clientWithoutToken({
            method: 'DELETE',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }
}

export { GuestService };
